import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
interface Review {
  name: string;
  location: string;
  gender: 'men' | 'women';
  photoId: number;
  rating: number;
  text: string;
}
const reviews: Review[] = [{
  name: 'Martín Gómez',
  location: 'Palermo, CABA',
  gender: 'men',
  photoId: 12,
  rating: 5,
  text: 'Tenía unos billetes de 100 muy manchados que nadie me quería tomar. Me cotizaron en minutos por WhatsApp y cerramos la operación el mismo día. Súper recomendable.'
}, {
  name: 'Sofía Ramírez',
  location: 'Belgrano, CABA',
  gender: 'women',
  photoId: 44,
  rating: 5,
  text: 'Atención impecable y muy transparentes con el estado del billete. Me explicaron todo y la cotización fue justa. Volvería sin dudarlo.'
}, {
  name: 'Lucas Fernández',
  location: 'Rosario, Santa Fe',
  gender: 'men',
  photoId: 32,
  rating: 5,
  text: 'Tenía dólares rotos guardados hace años pensando que no valían nada. FG Divisas me los compró y coordinamos todo rápido y seguro.'
}, {
  name: 'Valentina Morales',
  location: 'Córdoba Capital',
  gender: 'women',
  photoId: 65,
  rating: 5,
  text: 'Respuesta en minutos y sin compromiso. Mandé las fotos y a los pocos minutos ya tenía el valor. Muy profesionales.'
}, {
  name: 'Joaquín Díaz',
  location: 'La Plata, Bs. As.',
  gender: 'men',
  photoId: 76,
  rating: 4,
  text: 'Buenísima la experiencia. Billetes escritos y con sellos que en otros lados no me tomaban. Acá me dieron una cotización más que razonable.'
}, {
  name: 'Camila Suárez',
  location: 'Mar del Plata, Bs. As.',
  gender: 'women',
  photoId: 28,
  rating: 5,
  text: 'La mejor atención personalizada que recibí. Me acompañaron en todo el proceso y me sentí segura en la operación. 100% recomendados.'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring' as const,
      stiffness: 120,
      damping: 18
    }
  }
};
export function Reviews() {
  return <section className="py-24 bg-slate-50 border-t border-slate-200 relative overflow-hidden" data-id="element-122">
      {/* Ambient background accents */}
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-blue-100/50 rounded-full blur-3xl pointer-events-none" data-id="element-123"></div>
      <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-blue-50 rounded-full blur-3xl pointer-events-none" data-id="element-124"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-126">
          <span className="inline-block bg-blue-100 text-blue-700 px-4 py-1.5 rounded-full text-sm font-semibold mb-4 border border-blue-200" data-id="element-127">
            Clientes satisfechos
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0a2540] mb-4" data-id="element-128">
            Reseñas y recomendaciones
          </h2>
          <div className="flex items-center justify-center gap-2 text-slate-600" data-id="element-129">
            <div className="flex" data-id="element-130">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-131" />)}
            </div>
            <span className="font-semibold text-[#0a2540]" data-id="element-132">4.9</span>
            <span className="text-sm" data-id="element-133">· basado en operaciones reales</span>
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-134">
          {reviews.map((review, index) => <motion.div key={index} variants={cardVariants} whileHover={{
          y: -6
        }} className="group bg-white border border-slate-200 rounded-2xl p-6 shadow-sm hover:shadow-xl hover:border-blue-200 transition-all duration-300 relative" data-id="element-135">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-slate-100 group-hover:text-blue-100 transition-colors duration-300" data-id="element-136" />

              <div className="flex mb-4" data-id="element-137">
                {[...Array(5)].map((_, i) => <Star key={i} className={`w-4 h-4 ${i < review.rating ? 'text-amber-400 fill-amber-400' : 'text-slate-200 fill-slate-200'}`} data-id="element-138" />)}
              </div>

              <p className="text-slate-600 leading-relaxed mb-6 relative z-10" data-id="element-139">
                “{review.text}”
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-slate-100" data-id="element-140">
                <img src={`https://randomuser.me/api/portraits/${review.gender}/${review.photoId}.jpg`} alt={review.name} className="w-11 h-11 rounded-full object-cover border-2 border-white shadow" loading="lazy" data-id="element-141" />
                <div data-id="element-142">
                  <p className="font-bold text-[#0a2540] text-sm leading-tight" data-id="element-143">
                    {review.name}
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-144">{review.location}</p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}